export default __webpack_public_path__ + "static/AppendixA-45ffd6c6c9c142c3587b8506070a4ea0.png";